import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'

import { EmptyState } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import IllustrationMagnifyingGlass from 'core/ui/assets/illustration-magnifying-glass.svg'

import user from 'legacy/utils/user'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getToken('space-3xl')};
`

export function AwardedEmptyState() {
  const shouldDisplaySignUpButton = !user.isLoggedIn()

  const location = useLocation()
  const history = useHistory()

  function handleOnSignUpButtonClick() {
    const search = queryString.parse(location.search)
    search['signup'] = 'true'
    history.replace({ search: queryString.stringify(search) })
  }

  const emptyStateAction =
    (shouldDisplaySignUpButton && {
      label: 'Sign up to start booking',
      onClick: handleOnSignUpButtonClick,
    }) ||
    undefined

  return (
    <Wrapper>
      <EmptyState
        title="There are no Awarded RFPs to see here"
        description="Receive invitation from shippers to see your awards here"
        illustration={IllustrationMagnifyingGlass}
        variant="panel"
        action={emptyStateAction}
      />
    </Wrapper>
  )
}
